import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPinIcon } from 'lucide-react';
const LocationChecker = () => {
  const [postcode, setPostcode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!postcode.trim()) {
      setError('Please enter a postcode');
      return;
    }
    // In a real app, you would validate the postcode against your service areas
    // For this prototype, we'll just navigate to services
    setError('');
    navigate('/services');
  };
  return <div className="w-full max-w-md" data-id="element-16">
      <h2 className="text-xl font-semibold mb-3" data-id="element-17">
        Find beauty services near you
      </h2>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2" data-id="element-18">
        <div className="relative flex-grow" data-id="element-19">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-20">
            <MapPinIcon className="h-5 w-5 text-gray-400" data-id="element-21" />
          </div>
          <input type="text" value={postcode} onChange={e => setPostcode(e.target.value)} placeholder="Enter your postcode" className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-22" />
        </div>
        <button type="submit" className="bg-teal-600 text-white py-3 px-6 rounded-md hover:bg-teal-700 transition-colors" data-id="element-23">
          Check Availability
        </button>
      </form>
      {error && <p className="text-red-500 mt-2 text-sm" data-id="element-24">{error}</p>}
    </div>;
};
export default LocationChecker;